var map = {
	"./en/Common.json": "0a2d",
	"./en/Core/Fields.json": "ecd5",
	"./en/Core/Footer.json": "173d",
	"./en/Core/Toolbar.json": "f26b",
	"./en/DateTime.json": "e51a",
	"./en/Home.json": "5cc6",
	"./en/Pages/CollectiveVacations.json": "e05a",
	"./en/Pages/Dashboard.json": "7f42",
	"./en/Pages/Delete.json": "cec2",
	"./en/Pages/DocumentTypes.json": "1241",
	"./en/Pages/Electricity.json": "6b1b",
	"./en/Pages/ElectricityBills.json": "921c",
	"./en/Pages/ElectricityConstants.json": "ff6a",
	"./en/Pages/ElectricityStats.json": "9bda",
	"./en/Pages/ElectricitySuppliers.json": "f328",
	"./en/Pages/EmailConfirmation.json": "cbed",
	"./en/Pages/EmployeeRoles.json": "0ea5",
	"./en/Pages/ForgotPassword.json": "82f6",
	"./en/Pages/Groupations.json": "2c84",
	"./en/Pages/Holidays.json": "e5c1",
	"./en/Pages/Login.json": "2d5e",
	"./en/Pages/Manufacturers.json": "8e76",
	"./en/Pages/Partners.json": "e5e9",
	"./en/Pages/PasswordReset.json": "d1c5",
	"./en/Pages/ProductSizes.json": "3524",
	"./en/Pages/Products.json": "0497",
	"./en/Pages/ProtectiveGear.json": "be38",
	"./en/Pages/RealLocations.json": "7176",
	"./en/Pages/RecordBookTypes.json": "764d",
	"./en/Pages/RecordBooks.json": "f39e",
	"./en/Pages/Reports.json": "76f8",
	"./en/Pages/ScheduledOvertimes.json": "fd0d",
	"./en/Pages/Sectors.json": "a7c6",
	"./en/Pages/SupportTickets.json": "cdb5",
	"./en/Pages/TransportTypes.json": "5000",
	"./en/Pages/TravelWarrantSuggestion.json": "5bce",
	"./en/Pages/TravelWarrants.json": "0b8b",
	"./en/Pages/UserCheckoutFormStatuses.json": "526f",
	"./en/Pages/UserCheckoutForms.json": "e847",
	"./en/Pages/Users.json": "b3ba",
	"./en/Pages/VacationRequests.json": "3ef7",
	"./en/Pages/Vacations.json": "1b7a",
	"./en/Pages/Vehicles.json": "d10b",
	"./en/Pages/WarehouseStates.json": "6897",
	"./en/Pages/WarehouseTransactions.json": "cac2",
	"./en/Pages/Warehouses.json": "aaa1",
	"./en/Pages/WorkplaceGroupationRules.json": "879b",
	"./en/Pages/WorkplaceProductRules.json": "b120",
	"./en/Pages/Workplaces.json": "c717",
	"./en/UserGenders.json": "f76c",
	"./en/VacationRequestStatuses.json": "2759",
	"./sr/Common.json": "dcb9",
	"./sr/Core/Fields.json": "d467",
	"./sr/Core/Footer.json": "e4e9",
	"./sr/Core/Toolbar.json": "27b5",
	"./sr/DateTime.json": "cdb3",
	"./sr/Home.json": "4508",
	"./sr/Pages/CollectiveVacations.json": "3f98",
	"./sr/Pages/Dashboard.json": "7d4c",
	"./sr/Pages/Delete.json": "835d",
	"./sr/Pages/DocumentTypes.json": "4347",
	"./sr/Pages/Electricity.json": "47da",
	"./sr/Pages/ElectricityBills.json": "14dd",
	"./sr/Pages/ElectricityConstants.json": "638c",
	"./sr/Pages/ElectricityStats.json": "0fe7",
	"./sr/Pages/ElectricitySuppliers.json": "32a0",
	"./sr/Pages/EmailConfirmation.json": "eca9",
	"./sr/Pages/EmployeeRoles.json": "41bd",
	"./sr/Pages/ForgotPassword.json": "2be0",
	"./sr/Pages/Groupations.json": "e1f8",
	"./sr/Pages/Holidays.json": "209f",
	"./sr/Pages/Login.json": "2102",
	"./sr/Pages/Manufacturers.json": "2f06",
	"./sr/Pages/Partners.json": "bb92",
	"./sr/Pages/PasswordReset.json": "2518",
	"./sr/Pages/ProductSizes.json": "71e5",
	"./sr/Pages/Products.json": "c680",
	"./sr/Pages/ProtectiveGear.json": "a035",
	"./sr/Pages/RealLocations.json": "34e1",
	"./sr/Pages/RecordBookTypes.json": "9edf",
	"./sr/Pages/RecordBooks.json": "de18",
	"./sr/Pages/Reports.json": "d382",
	"./sr/Pages/ScheduledOvertimes.json": "a853",
	"./sr/Pages/Sectors.json": "cd3b",
	"./sr/Pages/SupportTickets.json": "3658",
	"./sr/Pages/TransportTypes.json": "1c9f",
	"./sr/Pages/TravelWarrantSuggestion.json": "a4cc",
	"./sr/Pages/TravelWarrants.json": "d46e",
	"./sr/Pages/UserCheckoutFormStatuses.json": "e594",
	"./sr/Pages/UserCheckoutForms.json": "68c6",
	"./sr/Pages/Users.json": "37ef",
	"./sr/Pages/VacationRequests.json": "a090",
	"./sr/Pages/Vacations.json": "8523",
	"./sr/Pages/Vehicles.json": "19ed",
	"./sr/Pages/WarehouseStates.json": "6f35",
	"./sr/Pages/WarehouseTransactions.json": "4b5f",
	"./sr/Pages/Warehouses.json": "225f",
	"./sr/Pages/WorkplaceGroupationRules.json": "94e0",
	"./sr/Pages/WorkplaceProductRules.json": "18d3",
	"./sr/Pages/Workplaces.json": "147e",
	"./sr/UserGenders.json": "a096",
	"./sr/VacationRequestStatuses.json": "0bb7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4999";